// @flow

import React, { useState, useEffect } from "react";
import { localize } from "redux-i18n";
import classNames from "classnames";
import { v4 as uuid } from "uuid";
import { Button, GSGrid, Icons, Input } from "@components";

type PartialAnswerOption = $Exact<{
  answerOption: string,
}>;

type OwnProps = $Exact<{
  data?: Array<string>,
  schema: Object,
  onChange: Function,
  onSubmit: (data: Array<string>) => void,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export function AnswerOptionsForm(props: Props) {
  const [data, setData]: [Array<string>, Function] = useState(props.data || []);
  const [valid, setValid]: [boolean, Function] = useState(false);

  useEffect(() => {
    if (props.onChange) {
      props.onChange(data);
    }
  }, [data]);

  const addButton = (
    <Button className="link d-flex align-items-center justify-content-center" onClick={handleAdd}>
      <span className="material-icons font-size-26 mr-1">add</span>
      {props.t("ADD")}
    </Button>
  );

  function handleAdd() {
    if (data.findIndex(d => d === "") > -1) return;
    setData([...data, ""]);
  }

  function handleRemove(id: string) {
    return function(params) {
      setData(data.filter(d => d !== id));
    };
  }

  function handleChange(idx: string) {
    return function(e) {
      const d = [...data];
      const recIdx = d.findIndex(r => r == idx);
      d[recIdx] = e.target.value;
      setData(d);
    };
  }

  return (
    <div className="d-flex flex-column">
      <div className="d-flex justify-content-end mb-2">{addButton}</div>
      {data.length <= 0 && (
        <h2 className="text-center text-grey fs-18">{props.t("NO_ANSWER_OPTIONS_ADDED")}</h2>
      )}
      {data.map((answer: string, idx: number) => {
        return (
          <div
            className="d-flex flex-1 align-items-center justify-content-between mb-1"
            key={`${idx}`}
          >
            <Input className="mr-1" name={idx} onChange={handleChange(answer)} value={answer} />
            <div className="material-icons cursor-pointer" onClick={handleRemove(answer)}>
              delete
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default localize()(AnswerOptionsForm);
